export default "__VITE_ASSET__CI0CB6de__"